<template>
    <div class="col-12" style="padding: 0!important; text-align: justify!important;">

        <div class="col-12" style="background-color: rgb(0 181 164 / 7%); padding: 0.2%; text-align: center">
            <img src="/images/contrat.png" alt="contrat-img" width="40%">
            <h3 style="font-size: 18pt!important;color: rgb(0 181 164)">Conditions générales d’utilisations des services
                d'Intram</h3>
            <p class="mt-5" style="font-size: 12pt">
                Services de paiement rapides et faciles aux entreprises
            </p>
        </div>

        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card" >
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">1. Votre relation avec Intram</h3>
            </div>
            <div class="mt-4">
                <h5>1.1. Présentation d'Intram</h5>

                <p style="font-size: medium!important;">
                    <strong>INTRAM</strong> est une société spécialisée dans les services financiers innovants et
                    disruptifs.
                    <strong>INTRAM</strong> est un Payment Service Provider (PSP), intermédiaire ou une personne tierce
                    qui fait de la mise en
                    relation entre une entreprise ou institution financière et son client pour le paiement d’un service
                    ou d’un bien.
                </p>

                <p style="font-size: medium!important;">
                    La plateforme Intram est une plateforme transactionnelle qui offre des services financiers aux
                    entreprises et institutions financières africains ou internationaux. Intram est un agrégateur qui en
                    partenariat avec les opérateurs de mobile money, services de transfert d’argent et banques permet
                    les paiements au niveau national et international. Les paiements sont effectués depuis le mobile
                    money, services de transfert d’argent et cartes bancaires vers un compte bancaire ou mobile money ou
                    transfert d’argent.
                </p>

                <p style="font-size: medium!important;">
                    Nous fournissons aux entreprises et institutions financières une suite de solutions digitales pour
                    vendre, recevoir des paiements, émettre des paiements et assurer une meilleure gestion.
                </p>


                <p style="font-size: medium!important;">
                    La plateforme Intram offre les solutions principales suivantes:
                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li><span class="elementPay">WebPay</span>: Réception des paiements sur site internet</li>
                    <li><span class="elementPay">MobPay</span>: Réception des paiements sur votre application mobile
                    </li>
                    <li><span class="elementPay">Collect</span>: Digitalisation des collectes récurrentes ou de masse
                    </li>
                    <li><span class="elementPay">Push</span>: Digitalisation des déboursements de masse</li>
                </ul>


                <p style="font-size: medium!important;">
                    La plateforme Intram offre les solutions annexes suivantes:
                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li><span class="elementPay">Transfert</span>: Réception des paiements sur votre application mobile
                    </li>
                    <li><span class="elementPay">Achat</span>: Effectuer les achats de vos articles sur votre
                        application mobile
                    </li>
                </ul>

            </div>
            <div class="mt-4">
                <h5>1.2. Respect de votre vie privée</h5>
                <p style="font-size: medium!important;">
                    La confidentialité et le respect de vos données personnelles et de paiements est importante pour
                    Intram.
                    Veuillez consulter notre <a href="javascript:void(0)">politique de confidentialité</a> pour avoir
                    plus de détail.
                </p>
            </div>
            <div class="mt-4">
                <h5>1.3. Propriété intellectuelle</h5>
                <p style="font-size: medium!important;">
                    Les URLs des sites web Intram, le nom "Intram" ainsi que tous les logos de nos produits et services
                    décrits sur nos sites web sont protégés par le droit d’auteur ou constituent des marques déposées de
                    INTRAM PayCfa.
                </p>

                <p style="font-size: medium!important;">
                    De plus, tous les en-têtes de page, images personnalisées, icônes debouton et scripts sont protégés
                    par
                    les droits d’auteur de Intram ouconstituent des marques commerciales et/ou l’identité visuelle de
                    Intram.
                    Vous ne pouvez pas les copier, les imiter, les modifier, ou les utiliser sans notre consentement
                    écrit préalable.
                    En tant qu’entreprise,vous pouvez utiliser les logos, images et scripts fournis par Intram via nos
                    services sans
                    notre consentement écrit préalable en vue de diriger du trafic Internet vers Intram. Vous ne pouvez
                    pas altérer,
                    modifier ou changer ces logos, images ou scripts en aucune manière, les utiliser d’une manière qui
                    déprécie Intram,
                    ou les afficher d’une manière impliquant que vous bénéficiez du soutien ou de l’approbation de
                    Intram.
                </p>

                <p style="font-size: medium!important;">
                    Toute reproduction, représentation ou exploitation des URLs des sites web Intram, du nom "Intram"
                    ainsi que tous les
                    logos de nos produits et services décrits sur nos sites web les en-têtes de page, images
                    personnalisées,
                    icônes de bouton et scripts les marques commerciales et/ou l’identité visuelle de Intram en
                    violation des
                    droits de propriété intellectuelle qui y sont attachés ou qui n’a pas fait l’objet d’une
                    autorisation préalable et expresse de
                    Intram ou de ses ayants droit est un acte de contrefaçon au sens du code de la propriété et expose
                    son auteur à des sanctions pénales.
                </p>


            </div>

            <div class="mt-4">
                <h5>1.4. Cession de compte Intram</h5>
                <p style="font-size: medium!important;">
                    Vous ne pouvez céder aucun droit ni aucune obligation ou transférer votre compte Intram
                    à un tiers dans le cadre du présent Contrat sans le consentement écrit préalable de Intram.
                </p>
            </div>

            <div class="mt-4">
                <h5>1.5. Notifications qui vous sont destinées</h5>
                <p style="font-size: medium!important;">
                    Vous acceptez que Intram puisse vous adresser une notification ou toute autre information en la
                    publiant dans
                    votre Compte, ou en l’envoyant à l’adresse email ou à l’adresse postale indiquée dans votre
                    Compte, ou en vous appelant au téléphone ou en vous envoyant un SMS.
                </p>
                <p style="font-size: medium!important;">
                    Les SMS envoyés aux tiers par les utilisateurs des services proposés par Intram
                    relève de leur entière responsabilité. A ce titre ils doivent se conformer à la loi de 2008
                    relative à la protection des données à caractère Personnel en ayant toutes les autorisations
                    requises par la CDP à cet effet. Toute violation relève de l’entière responsabilité du et/ou des
                    utilisateur(s) fautif(s),
                    et ne saurait en aucun cas engagé la responsabilité pénale et/ou civil de Intram
                </p>
                <p style="font-size: medium!important;">
                    À l’exception des notifications relatives aux modifications apportées au présent Contrat,
                    nous considérerons que vous aurez reçu toute notification que nous vous aurons adressée dans les
                    24 heures suivant sa publication dans votre Compte ou son envoi par email ou SMS.
                    Si la notification est envoyée par courrier postal,
                    nous considérerons que vous l’aurez reçue cinq jours ouvrés après son envoi.
                </p>
                <p style="font-size: medium!important;">
                    Vous pouvez également refuser de recevoir ces informations par voie électronique en contactant
                    Intram, dans ce cas Intram se réserve le droit de supprimer votre
                    Compte si vous refusez de recevoir ces informations par voie électronique.
                </p>


            </div>

            <div class="mt-4">
                <h5>1.6. Notifications destinées à Intram</h5>
                <p style="font-size: medium!important;">
                    Toute notification envoyée à Intram dans le cadre du présent Contrat doit être adressée par courrier
                    électronique à l’adresse
                    <a href="mailto:legal@intram.org">legal@intram.org</a>.
                </p>
            </div>

            <div class="mt-4">
                <h5>1.7. Historiques des transactions</h5>
                <p style="font-size: medium!important;">
                    Sauf lorsque votre Compte est restreint, vous pouvez accéder aux
                    détails des transactions de paiement exécutées et à
                    d’autres informations relatives à l’historique de vos transactions dans votre Compte.
                </p>
            </div>

            <div class="mt-4">
                <h5>1.8. Modifications du présent Contrat sur les Conditions Générales d’Utilisations et du Règlement
                    sur le respect de la vie privée</h5>
                <p style="font-size: medium!important;">
                    Nous pouvons à tout moment modifier le présent Contrat ou le Règlement
                    sur le respect de la vie privée, supprimer certaines de ses clauses ou en
                    ajouter de nouvelles, y compris s’agissant des commissions ou frais appliqués
                    aux paiements traités par Intram. Toute modification sera faite de manière
                    unilatérale par Intram et vous serez réputé avoir accepté les modifications
                    après en avoir reçu notification. Nous vous informerons des modifications un (1) mois
                    avant son entrée en vigueur, sauf dans les cas où les modifications sont exigées par la
                    loi ou relative de l’ajout d’un nouveau service ou d’une nouvelle fonctionnalité aux services
                    existants ou toute autre modification dont nous estimons de manière raisonnable qu’elle ne
                    diminue vos droits ni n’accroit vos responsabilités. Dans ce cas, les modifications seront
                    effectuées
                    sans qu’aucune notification préalable ne vous soit adressée et sera immédiatement applicable.
                </p>
                <p style="font-size: medium!important;">
                    Si vous refusez une quelconque modification, vous devez fermer votre Compte.
                    Si vous ne manifestez pas votre refus des modifications appliquées par la fermeture
                    de votre Compte au cours de la période de préavis d’un (1) mois, vous serez réputé
                    avoir accepté les modifications. Bien que vous puissiez fermer votre Compte à tout
                    moment et sans frais, veuillez noter que vous demeurerez responsable vis-à-vis de
                    Intram après votre résiliation du
                    présent Contrat du respect de toute obligation née avant la résiliation du présent Contrat.
                </p>

            </div>
            <div class="mt-4">
                <h5>1.9. Activités interdites</h5>
                <p style="font-size: medium!important;">
                    Intram ne doit pas être utilisé pour des activités:
                </p>
                <ul style="margin-left: 3%; font-size: medium">
                    <li>qui violent une loi, un contrat, une ordonnance ou une réglementation;
                    <li>en lien avec des transactions impliquant des produits qui présentent un risque pour la sécurité
                        du consommateur; des drogues et objets associés; des objets illégaux ou objets visant à
                        encourager, promouvoir et faciliter des activités illégales ou à expliquer à d’autres personnes
                        comment les mener; des objets volés notamment des biens numériques, virtuels et physiques; des
                        objets qui prônent la haine, la violence, l’intolérance raciale ou l’exploitation financière
                        d’actes criminels; des objets pouvant être considérés de nature obscène; des objets qui
                        enfreignent ou violent un/une quelconque droit d’auteur, marque déposée, droit de diffusion ou
                        droit lié à la protection de la vie privée ou tout autre droit de propriété conformément aux
                        lois;
                    </li>
                    <li>en lien avec des transactions qui révèlent les informations personnelles de tiers, en violation
                        des lois en vigueur; prennent en charge des systèmes pyramidaux ou des chaînes de Ponzi, des
                        systèmes matriciels, d’autres escroqueries;
                    </li>
                    <li>qui impliquent la vente de produits ou services identifiés par les agences gouvernementales
                        comme présentant une forte probabilité de fraude;
                    </li>
                    <li>qui impliquent des secteurs d’activités qui nécessitent une autorisation ou agrément des
                        autorités publiques comme par exemple la médecine, la pharmacie, les jeux d’argent, des
                        activités à jeux d’argent, notamment des jeux de casino, des paris sportifs, des courses
                        d’animaux, des billets de loterie, d’autres activités qui facilitent les jeux d’argent et des
                        tirages au sort sauf si ces derniers ont reçu l’autorisation d’exercer des autorités
                        compétentes.
                    </li>
                    <li>Intram se réserve le droit de bloquer le compte de son utilisateur, les transactions et les
                        fonds en cas de suspicions de fraudes et/ou de fraudes avérées. La durée du blocage dépendra de
                        la nature de la fraude, et nes aurait excéder 120 jours.
                    </li>
                </ul>

            </div>

            <div class="mt-4">
                <h5>1.10. Limitation de la responsabilité de Intram</h5>
                <p style="font-size: medium!important;">
                    Intram n’est pas responsable de la non jouissance ou non réception du
                    bien ou service payer par son intermédiaire, mais une réclamation peut être déposée
                    par le client contre l’entreprise/marchand/startup auprès du service client de Intram;
                </p>
                <p style="font-size: medium!important;">
                    Cependant cette réclamation ne confère en aucun cas à son auteur un droit à l’égard de Intram.
                    À ce titre son auteur ne saurait en prévaloir comme moyen de preuve pour ester en justice contre
                    Intram.
                </p>
                <p style="font-size: medium!important;">
                    Intram est responsable de la mise en relation entre l’entreprise et son client au moment du paiement
                    et du processus de paiement;
                </p>
                <p style="font-size: medium!important;">
                    Intram ne garantit pas la fiabilité de l’entreprise sur laquelle vous effectuer le paiement.
                </p>

            </div>


            <div class="mt-4">
                <h5>1.11. Lutte contre le blanchiment d’argent et financement du terrorisme</h5>
                <p style="font-size: medium!important;">
                    Conformément à la Directive N° 07/2002/CM/UEMOA relative à la lutte contre
                    le blanchiment de capitaux dans les Etats membres de l’UEMOA, Intram a pris
                    des mesures afin d’éviter que ses services soient utilisés à des fins de blanchiment
                    d’argent ou tout autres crimes financiers. A ce titre Intram prend des mesures pour
                    éviter d’être exposé au blanchiment de capitaux et au financement du terrorisme,
                    identifie les domaines dans lesquels le blanchiment de capitaux et le financement
                    du terrorisme peuvent se produire et se conformer aux exigences légales et
                    réglementaires en vigueur dans l’UEMOA, en particulier le processus de notification
                    des cas de blanchiment de capitaux et de financement du terrorisme réels ou présumés
                    au Centre National de Traitement des Informations Financières (CENTIF). A cet effet,
                    une politique de Conformité qui engage les clients des services de Intram est mise
                    en place et les engagent à ne pas utiliser les services de Intram à des fins de
                    criminalité financière.Conformément à la Directive N° 07/2002/CM/UEMOA relative à
                    la lutte contre le blanchiment de capitaux dans les Etats membres de l’UEMOA, Intram
                    a pris des mesures afin d’éviter que ses services soient utilisés à des fins de blanchiment
                    d’argent ou tout autres crimes financiers. A ce titre Intram prend des mesures pour éviter
                    d’être exposé au blanchiment de capitaux et au financement du terrorisme, identifie les domaines
                    dans lesquels le blanchiment de capitaux et le financement du terrorisme peuvent se produire et
                    se conformer aux exigences légales et réglementaires en vigueur dans l’UEMOA, en particulier le
                    processus de notification des cas de blanchiment de capitaux et de financement du terrorisme réels
                    ou présumés au Centre National de Traitement des Informations Financières (CENTIF). A cet effet,
                    une politique de Conformité qui engage les clients des services de Intram est mise en place et
                    les engagent à ne pas utiliser les services de Intram à des fins de criminalité financière.

                </p>


            </div>


        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">2. Accessibilités et types de comptes</h3>
            </div>
            <div class="mt-4">
                <h5>2.1. Eligibilité</h5>

                <p style="font-size: medium!important;">
                    Pour être éligible à nos services
                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li>de compte Entreprise, vous devez ne pas être sur liste noire de
                        Intram ou d’un pays où Intram opère, disposer des documents
                        d’établissement dans votre pays d’activité, disposer d’un numéro de
                        téléphone mobile et d’une adresse e-mail;
                    </li>
                </ul>
                <p style="font-size: medium!important;">
                    en tant que Payeur, vous devez ne pas être sur liste noire de Intram ou d’un pays où Intram
                    opère, utiliser l’un de nos moyens de paiements à savoir: votre compte de mobile money,
                    un service de transfert
                    d’argent ou une carte bancaire et enfin disposer des fonds nécessaires
                    à votre paiement sur votre moyen de paiement.
                </p>

                <p style="font-size: medium!important;">
                    Cependant, Intram se réserve le droit d’accepter votre adhésion ou non à sa plateforme pour
                    utilisation de ces services.
                    Intram se réserve aussi le droit de vous accorder une dérogation sur un document manquant ou en
                    cours de production.
                </p>


            </div>

            <div class="mt-4">
                <h5>2.2. Type de compte</h5>
                <p style="font-size: medium!important;">
                    Nous proposons deux types de comptes : le Compte Client et le Compte marchand. A moins qu’il n’en
                    soit convenu autrement,
                    vous ne pouvez pas être titulaire de plus d’un Compte Client. En ouvrant un Compte Client et en
                    acceptant
                    les termes et conditions décrits dans le présent Contrat, vous avez la posibilité de créer par la
                    suite plusieurs
                    comptes marchand chacune pour vos différentes entreprises.

                </p>

                <p style="font-size: medium!important;">
                    Vous pouvez consulter toutes les informations en rapport avec votre compte client et / ou vos
                    comptes marchand
                    et vos transactions suivant chaque compte
                    en vous connectant à votre Compte Client. Des informations clés relatives à vos paiements vous
                    seront fournies par email si vous le désirez et l’historique de vos transactions sera mis à jour
                    et disponible à tout moment en vous connectant à votre Compte.
                    Vous serez également en mesure d’accéder à un rapport téléchargeable au format PDF et/ou Excel dans
                    votre Compte.
                </p>

            </div>

        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">3. Paiements</h3>
            </div>
            <div class="mt-4">
                <h5>3.1. Mise à disposition des Moyens de Paiements</h5>

                <p style="font-size: medium!important;">
                    Intram s’engage à mettre à disposition des utilisateurs les moyens de paiement
                    intégrés sur sa plateforme à l’exception des cartes bancaires si l’utilisateur
                    n’est pas installé dans l’un des pays suivant :
                    Bénin, sauf cas particulier.


                </p>
            </div>

            <div class="mt-4">
                <h5>3.2. Paiements réussis</h5>
                <p style="font-size: medium!important;">
                    Lorsque vous recevez un paiement, vous êtes notifié sur votre tableau de bord, par email et/ou SMS
                    instantanément
                    ou en différé en fonction du moyen de paiement utilisé par le payeur. Le montant payé déduit des
                    frais de services de Intram
                    s’ajoute automatiquement au solde de votre Compte. Selon les services de Intram
                    qui ont été utilisé, vous pouvez être notifié sur votre plateforme web, mobile ou logicielle tierce.
                </p>

            </div>

            <div class="mt-4">
                <h5>3.3. Paiements refusés</h5>
                <p style="font-size: medium!important;">
                    Lorsque qu’un paiement est effectué, si une seule étape de la procédure n’est pas validée
                    (informations erronées dans la boîte de dialogue, mauvais code secret, solde insuffisant,
                    mauvaise syntaxe du script envoyé par votre plateforme tierce, non confirmation sur votre téléphone
                    etc),
                    la transaction est automatiquement interrompue et annulée et votre solde reste inchangé.
                </p>

            </div>

            <div class="mt-4">
                <h5>3.4. Délais de traitements des paiements et retraits d’argent</h5>
                <p style="font-size: medium!important;">
                    Les paiements sont traités automatiquement et le paiement est confirmé instantanément.
                    Le rechargement de votre Compte ou les paiements que vous recevez peuvent selon la disponibilité
                    du réseau durer plusieurs minutes, cela est indépendant des ressources techniques de Intram.
                </p>
                <p style="font-size: medium!important;">
                    Le retrait d’argent de votre Compte vers votre compte bancaire ou mobile money
                    ou en cash via un réseau partenaire de Intram est effectué selon les délais de traitement
                    du moyen de paiement mais ne peut en général excédé les vingt-quatre heures qui suivent
                    la demande de retrait pour le mobile money ou
                    cash et soixante douze heures pour le compte bancaire dans la zone UEMOA.
                </p>
                <p style="font-size: medium!important;">
                    Si un paiement ou un retrait n’est pas possible, Intram
                    vous communiquera instantanément ou à la demande la raison de ce refus.
                </p>
            </div>
            <div class="mt-4">
                <h5>3.5. Paiement en différentes devises ou monnaies</h5>
                <p style="font-size: medium!important;">
                    Intram supporte qu’une seule monnaie pour le moment, cette dernière est le XOF : Franc CFA de
                    l’Union Economique et Monétaire de l’Afrique de Ouest (UEOMA).
                </p>
                <p style="font-size: medium!important;">
                    Toute montant en devise ou monnaie étrangère devra être convertie avant d’être envoyée
                    à Intram uniquement en XOF. Intram ne s’engage pas dans le
                    traitement de transaction en devise ou monnaie étrangère.
                </p>

            </div>


        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">4. Durée du Contrat et gestion de votre
                    Compte</h3>
            </div>
            <div class="mt-4">
                <h5>4.1. Durée du Contrat et procédure de fermeture, suspension et restriction du Compte</h5>

                <p style="font-size: medium!important;">
                    Le présent Contrat entre en vigueur au moment où vous créez un Compte et le restera jusqu’à ce que
                    le
                    Compte soit résilié, quelle qu’en soit la raison. Sous réserve des termes de l’article 4.2, vous
                    pouvez
                    fermer votre Compte et résilier le présent Contrat à tout moment en vous connectant à votre Compte
                    et en
                    cliquant sur l’onglet "Paramètres", puis ’Autres’ et puis sur "Supprimer mon compte". Vous pouvez
                    également
                    suspendre votre Compte en cliquant sur l’onglet "Paramètres", puis "Autres" et puis sur "Suspendre
                    mon compte",
                    vous ne pourrez ainsi plus mener aucune
                    transaction mais le présent contrat reste valable et votre Compte ré activable à tout moment.
                </p>
            </div>

            <div class="mt-4">
                <h5>3.2. Paiements réussis</h5>
                <p style="font-size: medium!important;">
                    Lorsque vous recevez un paiement, vous êtes notifié sur votre tableau de bord, par email et/ou SMS
                    instantanément
                    ou en différé en fonction du moyen de paiement utilisé par le payeur. Le montant payé déduit des
                    frais de services de Intram
                    s’ajoute automatiquement au solde de votre Compte. Selon les services de Intram
                    qui ont été utilisé, vous pouvez être notifié sur votre plateforme web, mobile ou logicielle tierce.
                </p>

            </div>

            <div class="mt-4">
                <h5>3.3. Paiements refusés</h5>
                <p style="font-size: medium!important;">
                    Lorsque qu’un paiement est effectué, si une seule étape de la procédure n’est pas validée
                    (informations erronées dans la boîte de dialogue, mauvais code secret, solde insuffisant,
                    mauvaise syntaxe du script envoyé par votre plateforme tierce, non confirmation sur votre téléphone
                    etc),
                    la transaction est automatiquement interrompue et annulée et votre solde reste inchangé.
                </p>

            </div>

            <div class="mt-4">
                <h5>3.4. Délais de traitements des paiements et retraits d’argent</h5>
                <p style="font-size: medium!important;">
                    Les paiements sont traités automatiquement et le paiement est confirmé instantanément.
                    Le rechargement de votre Compte ou les paiements que vous recevez peuvent selon la disponibilité
                    du réseau durer plusieurs minutes, cela est indépendant des ressources techniques de Intram.
                </p>
                <p style="font-size: medium!important;">
                    Le retrait d’argent de votre Compte vers votre compte bancaire ou mobile money
                    ou en cash via un réseau partenaire de Intram est effectué selon les délais de traitement
                    du moyen de paiement mais ne peut en général excédé les vingt-quatre heures qui suivent
                    la demande de retrait pour le mobile money ou
                    cash et soixante douze heures pour le compte bancaire dans la zone UEMOA.
                </p>
                <p style="font-size: medium!important;">
                    Si un paiement ou un retrait n’est pas possible, Intram
                    vous communiquera instantanément ou à la demande la raison de ce refus.
                </p>
            </div>
            <div class="mt-4">
                <h5>3.5. Paiement en différentes devises ou monnaies</h5>
                <p style="font-size: medium!important;">
                    Intram supporte qu’une seule monnaie pour le moment, cette dernière est le XOF : Franc CFA de
                    l’Union Economique et Monétaire de l’Afrique de Ouest (UEOMA).
                </p>
                <p style="font-size: medium!important;">
                    Toute montant en devise ou monnaie étrangère devra être convertie avant d’être envoyée
                    à Intram uniquement en XOF. Intram ne s’engage pas dans le
                    traitement de transaction en devise ou monnaie étrangère.
                </p>

            </div>


        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">5. Commissions</h3>
            </div>
            <div class="mt-4">

                <p style="font-size: medium!important;">
                    Les commissions sont prélevées sur chaque transaction à celui
                    qui reçoit les fonds, celui qui effectue le paiement paie exactement le montant net à payer.
                </p>
                <p style="font-size: medium!important;">
                    Des frais supplémentaires peuvent-être facturés dans certains cas pour:
                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li>couvrir nos coûts de traitement de virement de fonds (inter Etats ou hors UEMOA);</li>
                    <li>convertir des devises le cas échéant;</li>
                    <li>souscrire à des services proposés en option par Intram.</li>
                </ul>
            </div>
        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card mb-4">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">6. Erreurs et transactions non autorisées
                </h3>
            </div>
            <div class="mt-4">

                <p style="font-size: medium!important;">
                    Vous pouvez consulter l’historique de vos transactions à tout moment en vous connectant à
                    votre Compte. Il est très important que vous informiez Intram immédiatement
                    si vous avez des raisons de croire que l’une des situations suivantes s’est présentée:
                </p>
                <p style="font-size: medium!important;">
                    Des frais supplémentaires peuvent-être facturés dans certains cas pour:
                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li>une transaction non autorisée par vous a été effectuée sur votre Compte;</li>
                    <li>un accès non autorisé est survenu sur votre Compte;</li>
                    <li>votre téléphone mobile ou ordinateur a été perdu, volé ou désactivé;</li>
                    <li>si vous avez des raisons de penser qu’une erreur a été commise sur votre Compte;</li>
                    <li>si vous pensez qu’il y a eu ou qu’il pourrait y avoir une erreur, une transaction non autorisée,
                        une utilisation inappropriée ou non autorisée de Intram ou de votre Compte.</li>
                </ul>
            </div>





    </div>
    </div>
</template>

<script>
    export default {
        name: "conditionsUtilisateur",
        methods: {
            checkisDashboard() {
                this.$emit('checkisDashboard', false);
            },
        }
    }
</script>

<style scoped>
    .elementPay {
        color: #00B7A4;
        font-weight: bold;
    }

    .border-top-card{
        border-top: #00B7A4 solid 5px;
    }


</style>